<script>
  import { debounce, whenFastSimonReady, reportProductSwatchSwitch, buildSizedImageUrl, buildResponsiveSrcset, fetchRatingsForHandles, handleViewportSize, buildProductTitleSearchQuery } from '@/lib/vue-helpers.js';
  import { productStore } from '@/lib/productStore.js';
  import storefront from '@/lib/storefront.js';
  import * as queries from '@/lib/queries.js';
  import ProductListTopLeftBadge from '@/components/ProductListTopLeftBadge.vue';
  import ProductListBottomPillBadge from '@/components/ProductListBottomPillBadge.vue';
  import ProductListTextUnderBadge from '@/components/ProductListTextUnderBadge.vue';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
  import 'vue3-carousel/dist/carousel.css';
  import { emitter } from '@/main.js';
  import { syncVueCarouselCloneInert } from '@/vueCarouselCloneInert.js';

  let peekABooFired = false;
  let tileShowingMobileDots = null;
  const SWIPE_VERTICAL_DRIFT_TOLERANCE_PX = 10;

  export default {
    components: {
      ProductListTopLeftBadge,
      ProductListBottomPillBadge,
      ProductListTextUnderBadge,
      Carousel,
      Slide,
      Pagination,
      Navigation
    },
    name: 'ProductListItem',
    props: {
      fsData: Object,
      useFsProductData: Boolean,
      collectionHandle: String,
      collectionId: String,
      disableSlider: Boolean,
      getCurrentLocales: String,
      gridLarge: Number,
      gridSmall: Number,
      hideSwatches: Boolean,
      hideQuickview: Boolean,
      imageLookUpMax: Number,
      parentActiveSlider: String,
      pid: String,
      productAttrObj: Object,
      productCategoryMetafieldOne: String,
      productCategoryMetafieldTwo: String,
      productCategoryMetafieldOneCollection: String,
      productCategoryMetafieldTwoCollection: String,
      productImageName: String,
      productIndex: Number,
      productPLPDescription: String,
      productReminderMetafieldEmbed: String,
      productTitle: String,
      productsToCompare: Set,
      productTypesExcluded: String,
      searchTerm: String,
      setReminderFormIdPopup: String,
      setReminderLinkText: String,
      showFullDetailsLink: {
        type: Boolean,
        required: false,
        default: false
      },
      sliderIDActive: String,
      sliderIDLast: String,
      slideIndex: {
        type: Number,
        required: true
      },
      swatchSuffix: String,
      showSalePercentage: {
        type: Boolean,
        required: false,
        default: false
      },
      showRating: {
        type: Boolean,
        required: false,
        default: false
      },
      ratingStarColor: {
        type: String,
        required: false,
        default: ''
      },
      ratingCountColor: {
        type: String,
        required: false,
        default: ''
      },
      collectionTracking: Boolean,
      badgeHideConfig: {
        type: Object,
        default: () => ({})
      },
      fsWidgetId: {
        type: String,
        default: ''
      },
      fsProductPosition: {
        type: Number,
        default: 0
      },
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      kameleoonCompareEnabled: {
        type: Boolean,
        default: true
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      enableMobilePeekABoo: {
        type: Boolean,
        default: false
      },
      enableMobileImageSwipe: {
        type: Boolean,
        default: false
      }
    },
    emits: ['currentCarouselSlideStart', 'countCarouselsLoaded', 'update:productsToCompare', 'toggle-compare', 'tile-ready'],
    watch: {
      sliderIDActive: {
        handler(newValue) {
          if (newValue === this.activePid) {
            this.hideMe = false;
          } else {
            this.hideMe = true;
          }
        }
      },
      sliderIDLast: {
        handler(newValue) {
          if (newValue === this.activePid) {
            this.resetCarousel();
          }
        }
      },
      colors: {
        handler() {
          this.$nextTick(() => {
            this.applyCarouselARIA();
          });
        },
        deep: false
      }
    },
    data() {
      return {
        activePid: '',
        aspectRatio: 0,
        bodyClasses: '',
        bodyID: '',
        colors: [],
        colorsCount: 0,
        tileReadyEmitted: false,
        countryCode: '',
        currencyCode: '',
        currentSlide: 0,
        gridSizeBasedSwatches: 1,
        hideMe: true,
        isHovering: false,
        isPeeking: false,
        isProgrammaticSlide: false,
        mobileShowPaginationDots: false,
        mobileDotsScrollAnchor: null,
        tileTouchActive: false,
        tileTouchDragged: false,
        tileTouchStartScrollY: 0,
        intentDwellTimer: null,
        filterUpdateHandler: null,
        gridSizeLargeHandler: null,
        gridSizeSmallHandler: null,
        sidebarClickHandler: null,
        sidebarResetTimeout: null,
        itemsToScroll: 1,
        itemsToShow: 1,
        lessThan3Swatches: false,
        lessThan5Swatches: false,
        metafieldValueSplit: [],
        mouseDrag: false,
        pagination: '',
        PIDshowing: false,
        prices: [],
        product: '',
        productIsFragrance: true,
        productIsType: '',
        productsByTitleLookup: parseInt(window.siteGlobals.plp_productsByTitleLookup),
        productSwatchesHidden: false,
        reminderFormIDEmbed: '',
        reminderFormIDPopup: '',
        rootUrl: window.Shopify.routes.root || window.location.origin,
        sellOutSettings: false,
        enableLazyLoading: typeof window !== 'undefined' && window.theme && window.theme.settings ? Boolean(window.theme.settings.enable_lazy_loading) : true,
        setReminderMetafield: '',
        setReminderPDP: false,
        setReminderPDPHideSizes: false,
        setReminderProductLink: false,
        setReminderTag: '',
        shouldAutoPlay: 0,
        slideInitialPid: '',
        slideNewPid: '',
        slideTimeOut: 1500,
        soldOutTag: '',
        swatchLimits: {
          mobile: 3,
          tablet: 4,
          desktop: 6
        },
        swatchType: '',
        touchDrag: false,
        vendor: '',
        hasReorganized: false,
        reorganizedColors: [],
        colorName: 'Color',
        enableCompare: false,
        plpAllowedCompareCollectionIds: [],
        rating: null,
        ratingCount: null,
        productCategoryMetafieldOneCollectionUrl: '',
        productCategoryMetafieldTwoCollectionUrl: '',
        showVendor: false,
        addVendorLink: false,
        defaultVendor: '',
        vendorColorText: '',
        vendorCollectionExists: false,
        collectionIdFallback: '',
        isPlpRoute: false,
        plpQuickviewIconAlt: typeof window !== 'undefined' ? window.siteGlobals?.plp_quickview_icon_alt || '' : '',
        plpQuickviewAriaLabel: typeof window !== 'undefined' ? window.siteGlobals?.plp_quickview_aria_label || '' : ''
      };
    },
    computed: {
      resolvedCollectionId() {
        return this.collectionId || this.collectionIdFallback || '';
      },
      compareCount() {
        return this.productsToCompare ? this.productsToCompare.size : 0;
      },
      compareSetSize() {
        const currentSet = this.$props.productsToCompare || this.productsToCompare;
        return currentSet?.size || 0;
      },
      compareSetIds() {
        const currentSet = this.$props.productsToCompare || this.productsToCompare;
        if (!currentSet) return [];
        return Array.from(currentSet)
          .map(p => String(p?.pid || p?.id))
          .filter(Boolean);
      },
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      enableCompareResolved() {
        return this.kameleoonCompareEnabled && this.enableCompare;
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      /**
       * Returns the current device type and swatch limit for color swatches.
       * @returns {{ device: string, limit: number }}
       */
      swatchConfig() {
        const device = this.getClientWidth();
        const limits = {
          'mobile-size': this.swatchLimits.mobile,
          'tablet-size': this.swatchLimits.tablet,
          'desktop-size': this.swatchLimits.desktop
        };
        return {
          device,
          limit: Number(limits[device])
        };
      },
      /**
       * Returns colors array reorganized to ensure active color is always visible
       *
       * This computed property solves the problem where the currently selected color
       * might be hidden when there are more colors than the display limit allows.
       *
       * Example: If limit is 4 and active color is at index 6:
       * Original: [color0, color1, color2, color3, color4, color5, activeColor6, color7, ...]
       * Result:   [color0, color1, color2, activeColor6, color4, color5, color7, ...]
       *
       * @returns {Array} Reorganized colors array with active color guaranteed visible
       */
      visibleColors() {
        if (this.hasReorganized && this.reorganizedColors.length) {
          return this.reorganizedColors;
        }
        return this.colors;
      },
      /**
       * Returns the count of remaining colors for the +N indicator
       *
       * This works in conjunction with visibleColors to show the correct count
       * of hidden colors, even when the array has been reorganized to show
       * the active color.
       *
       * The count remains consistent regardless of whether colors were reorganized,
       * since the total number of colors and the display limit don't change.
       *
       * @returns {number} Number of colors hidden beyond the visible limit
       */
      remainingColorsCount() {
        const activeIndex = this.colors.findIndex(color => color.pid === this.activePid);

        if (activeIndex === -1 || activeIndex < this.swatchConfig.limit) {
          return Math.max(0, this.colorsCount - this.swatchConfig.limit);
        }

        return Math.max(0, this.colorsCount - this.swatchConfig.limit);
      },
      /**
       * Determines if sale percentage should be displayed
       * @returns {boolean} True if showSalePercentage prop is true
       */
      shouldShowSalePercentage() {
        return this.showSalePercentage;
      },
      shouldShowMobilePlpQuickview() {
        if (this.hideQuickview || !this.isPlpRoute) return false;
        const sg = window.siteGlobals;
        if (!this.isCheckboxSettingOn(sg?.quickview_enable)) return false;
        return this.isCheckboxSettingOn(sg.mobile_plp_quickview_enable);
      },
      shouldShowDesktopPlpQuickview() {
        if (this.hideQuickview || !this.isPlpRoute) return false;
        const sg = window.siteGlobals;
        if (!this.isCheckboxSettingOn(sg?.quickview_enable)) return false;
        return this.isCheckboxSettingOn(sg.desktop_plp_quickview_enable);
      },
      shouldShowCrosssellQuickview() {
        if (this.hideQuickview || this.isPlpRoute) return false;
        const sg = window.siteGlobals;
        return this.isCheckboxSettingOn(sg?.quickview_enable);
      },
      shouldShowQuickviewIcon() {
        return this.shouldShowMobilePlpQuickview || this.shouldShowDesktopPlpQuickview || this.shouldShowCrosssellQuickview;
      },
      isCrosssellQuickviewIcon() {
        return this.shouldShowCrosssellQuickview;
      },
      showQuickviewMounted() {
        return this.shouldShowQuickviewIcon;
      },
      hasDesktopPlpImageSwatches() {
        return this.isPlpRoute && !!this.swatchSuffix && this.hideSwatches !== true && !this.productSwatchesHidden && this.colors?.length > 1;
      },
      plpQuickviewIconUrl() {
        const u = window.siteGlobals?.plp_quickview_icon_url;
        if (typeof u !== 'string') return '';
        const t = u.trim();
        return t.length ? t : '';
      },
      hasPlpQuickviewIcon() {
        return !!this.plpQuickviewIconUrl;
      },
      showPaginationDots() {
        if (this.disableSlider === true) {
          return false;
        }
        if (this.getClientWidth() === 'mobile-size') {
          return this.mobileShowPaginationDots;
        }
        return this.isHovering;
      },
      /**
       * Determines if vendor should be displayed
       * @returns {boolean} True if vendor should be shown
       */
      shouldShowVendor() {
        if (!this.showVendor || !this.vendor || typeof this.vendor !== 'string') return false;
        if (this.defaultVendor && typeof this.defaultVendor === 'string' && this.vendor.trim() === this.defaultVendor.trim()) return false;
        return true;
      },
      /**
       * Returns the vendor collection URL if vendor link is enabled and collection exists
       * @returns {string|null} URL to vendor collection or null
       */
      vendorUrl() {
        if (!this.addVendorLink || !this.vendor || typeof this.vendor !== 'string' || !this.vendorCollectionExists) return null;
        const handle = this.handleize(this.vendor);
        return window.theme.routes.root_url + 'collections/' + handle;
      },
      /**
       * Determines if swatches are visible for this product
       * @returns {boolean} True if color or image swatches are displayed
       */
      hasVisibleSwatches() {
        if (this.hideSwatches === true || this.productSwatchesHidden) return false;
        if (!this.colors?.length) return false;
        return true;
      },
      intrinsicImageHeight() {
        const str = this.aspectRatio || getComputedStyle(document.documentElement).getPropertyValue('--PRODUCT-GRID-ASPECT-RATIO-DECIMAL').trim() || '3 / 4';
        const [w, h] = str.includes('/') ? str.split('/').map(s => parseFloat(s.trim())) : [parseFloat(str) || 0.75, 1];
        return Math.round(500 / (w / h));
      }
    },
    created() {
      if (typeof document !== 'undefined') {
        const body = document.querySelector('body');
        this.bodyID = body?.id || '';
        this.bodyClasses = Array.from(body?.classList || []);
        this.isPlpRoute = this.resolveIsPlpRoute();
      }
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.activePid = this.pid;
      this.countryCode = window.Shopify.country;
      this.currencyCode = window.Shopify.currency.active;
      this.bodyID = document.querySelector('body').id;
      this.bodyClasses = Array.from(document.querySelector('body').classList);
      this.isPlpRoute = this.resolveIsPlpRoute();
      this.getCurrentPage();
      this.soldOutTag = window.siteGlobals.badge_sellout_tag;
      this.sellOutSettings = window.siteGlobals.badge_sellout;
      this.showVendor = window.siteGlobals?.show_vendor === 'true' || window.siteGlobals?.show_vendor === true;
      this.addVendorLink = false; // Disabled on PLPs/sections to prevent accidental taps
      this.defaultVendor = window.siteGlobals?.default_vendor || '';
      this.vendorColorText = window.siteGlobals?.vendor_color_text || '';

      if (this.useFsProductData == 'true') {
        this.setupDataFromFS();
      } else {
        if (this.hideSwatches != true) {
          this.getProductData();
        } else {
          this.getProductDataById();
        }
      }

      setTimeout(() => {
        this.applyCarouselARIA();
      }, 100);
      this.setReminderTag = window.siteGlobals.set_reminder_tag;
      this.setReminderMetafield = window.siteGlobals.set_reminder_metafield;
      this.setReminderProductLink = window.siteGlobals.set_reminder_product_link;
      this.setReminderPDP = window.siteGlobals.set_reminder_pdp;
      this.setReminderPDPHideSizes = window.siteGlobals.set_reminder_pdp_hide_sizes;

      if (this.useFsProductData === 'true') {
        const oneGid = this.extractGidFromUrl(this.productCategoryMetafieldOneCollection);
        const twoGid = this.extractGidFromUrl(this.productCategoryMetafieldTwoCollection);
        if (oneGid) {
          this.fetchCollectionUrl(oneGid, 'productCategoryMetafieldOneCollectionUrl');
        } else {
          this.productCategoryMetafieldOneCollectionUrl = this.productCategoryMetafieldOneCollection && !this.productCategoryMetafieldOneCollection.includes('gid://') ? this.productCategoryMetafieldOneCollection : '';
        }
        if (twoGid) {
          this.fetchCollectionUrl(twoGid, 'productCategoryMetafieldTwoCollectionUrl');
        } else {
          this.productCategoryMetafieldTwoCollectionUrl = this.productCategoryMetafieldTwoCollection && !this.productCategoryMetafieldTwoCollection.includes('gid://') ? this.productCategoryMetafieldTwoCollection : '';
        }
      } else {
        this.productCategoryMetafieldOneCollectionUrl = this.productCategoryMetafieldOneCollection && !this.productCategoryMetafieldOneCollection.includes('gid://') ? this.productCategoryMetafieldOneCollection : '';
        this.productCategoryMetafieldTwoCollectionUrl = this.productCategoryMetafieldTwoCollection && !this.productCategoryMetafieldTwoCollection.includes('gid://') ? this.productCategoryMetafieldTwoCollection : '';
      }

      if (this.productReminderMetafieldEmbed != '' && this.productReminderMetafieldEmbed != null) {
        let metafieldValueSplit = this.productReminderMetafieldEmbed.split('|');
        this.reminderFormIDEmbed = metafieldValueSplit[0];
        this.reminderFormIDPopup = metafieldValueSplit[1];
      }

      const dataElement = document.getElementById('fs-collection-products');
      if (dataElement != null) {
        this.aspectRatio = dataElement.getAttribute('data-grid-ratio');
        this.swatchType = dataElement.getAttribute('data-product_swatch_type');

        const mobile = dataElement.getAttribute('data-swatch_limit_mobile');
        const tablet = dataElement.getAttribute('data-swatch_limit_tablet');
        const desktop = dataElement.getAttribute('data-swatch_limit_desktop');

        this.swatchLimits = {
          mobile: mobile ? Number(mobile) : this.swatchLimits.mobile,
          tablet: tablet ? Number(tablet) : this.swatchLimits.tablet,
          desktop: desktop ? Number(desktop) : this.swatchLimits.desktop
        };

        const enableCompareAttr = dataElement.getAttribute('data-plp-enable-compare');
        const allowedIdsAttr = dataElement.getAttribute('data-plp-compare-collections') || '';
        const dataCollectionId = dataElement.getAttribute('data-collection-id') || '';
        if (!this.collectionId && dataCollectionId) {
          this.collectionIdFallback = String(dataCollectionId);
        }
        const requestedEnable = String(enableCompareAttr || '').toLowerCase() === 'true';
        const allowedIds = allowedIdsAttr
          .split(',')
          .map(s => String(s || '').trim())
          .filter(Boolean);
        this.plpAllowedCompareCollectionIds = allowedIds;
        this.enableCompare = requestedEnable && (!allowedIds.length || (this.resolvedCollectionId && allowedIds.includes(String(this.resolvedCollectionId))));
      }

      this.filterUpdateHandler = () => {
        this.resetCarousel();
      };
      this.gridSizeLargeHandler = e => {
        this.updateSwatchCountBasedOnGridSize(e);
      };
      this.gridSizeSmallHandler = e => {
        this.updateSwatchCountBasedOnGridSize(e);
      };
      this.sidebarClickHandler = () => {
        clearTimeout(this.sidebarResetTimeout);
        this.sidebarResetTimeout = setTimeout(() => {
          this.$nextTick(() => {
            this.resetCarousel();
          });
          this.sidebarResetTimeout = null;
        }, 500);
      };
      emitter.on('fs-update-filter', this.filterUpdateHandler);
      emitter.on('fs-update-grid-size-large', this.gridSizeLargeHandler);
      emitter.on('fs-update-grid-size-small', this.gridSizeSmallHandler);
      emitter.on('fs-sidebar-click', this.sidebarClickHandler);

      this.debouncedResize = debounce(
        () => {
          this.updateSwatchCountBasedOnGridSize();
        },
        500,
        false
      );
      document.addEventListener('theme:resize:width', this.debouncedResize);

      this.$watch(
        () => this.colors,
        colors => {
          if (!colors.length) return;
          const activeIndex = colors.findIndex(color => color.pid === this.activePid);
          if (activeIndex >= this.swatchConfig.limit) {
            const reorderedColors = [...colors];
            const activeColor = reorderedColors.splice(activeIndex, 1)[0];
            reorderedColors.splice(this.swatchConfig.limit - 1, 0, activeColor);
            this.reorganizedColors = reorderedColors;
            this.hasReorganized = true;
          } else {
            this.reorganizedColors = [];
            this.hasReorganized = false;
          }
        },
        { immediate: true, flush: 'post' }
      );
    },
    updated() {
      this.$nextTick(() => {
        if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
          return;
        }

        const carouselViewports = this.$el.querySelectorAll('.carousel__viewport');
        const carouselTracks = this.$el.querySelectorAll('.carousel__track');

        carouselViewports.forEach(el => {
          if (!el.hasAttribute('role')) {
            el.setAttribute('role', 'none');
          }
        });
        carouselTracks.forEach(el => {
          if (!el.hasAttribute('role')) {
            el.setAttribute('role', 'none');
          }
        });
      });
    },
    beforeUnmount() {
      if (tileShowingMobileDots === this) tileShowingMobileDots = null;
      this.stopHidingMobileDotsOnPageScroll();
      clearTimeout(this.intentDwellTimer);
      clearTimeout(this.sidebarResetTimeout);
      if (this.handleViewportSize) this.handleViewportSize();
      if (this.filterUpdateHandler) emitter.off('fs-update-filter', this.filterUpdateHandler);
      if (this.gridSizeLargeHandler) emitter.off('fs-update-grid-size-large', this.gridSizeLargeHandler);
      if (this.gridSizeSmallHandler) emitter.off('fs-update-grid-size-small', this.gridSizeSmallHandler);
      if (this.sidebarClickHandler) emitter.off('fs-sidebar-click', this.sidebarClickHandler);
      document.removeEventListener('theme:resize:width', this.debouncedResize);
    },
    methods: {
      isCheckboxSettingOn(val) {
        if (val === true) return true;
        const s = String(val == null ? '' : val)
          .trim()
          .toLowerCase();
        return s === 'true' || s === '1' || s === 'yes';
      },
      resolveIsPlpRoute() {
        const sg = window.siteGlobals;
        const pt = sg?.pageType ? String(sg.pageType).toLowerCase().trim() : '';
        if (pt === 'collection' || pt === 'search') return true;
        if (this.bodyClasses.includes('template-collection') || this.bodyClasses.includes('template-search')) return true;
        if (typeof document !== 'undefined' && document.getElementById('fs-collection-products')) return true;
        return false;
      },
      isCompareDisabled(item) {
        return this.compareSetSize >= 3 && !this.isItemCompared(item);
      },
      isItemCompared(item) {
        if (!item?.pid && !item?.id) return false;
        const itemId = String(item?.pid || item?.id);
        return this.compareSetIds.includes(itemId);
      },
      toggleCompare(item) {
        const isRemoving = this.isItemCompared(item);
        if (!isRemoving && this.compareSetSize >= 3) return;
        this.$emit('toggle-compare', item);
      },
      /**
       * Apply role="none" to carousel wrapper elements for ARIA compliance
       * Uses retry logic to handle async carousel initialization
       * @private
       * @param {number} retryCount - Current retry attempt (max 3)
       */
      applyCarouselARIA(retryCount = 0) {
        if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
          return;
        }

        const carouselViewports = this.$el.querySelectorAll('.carousel__viewport');
        const carouselTracks = this.$el.querySelectorAll('.carousel__track');

        if (carouselViewports.length === 0 && carouselTracks.length === 0) {
          if (retryCount < 3) {
            const delay = 100 * Math.pow(2, retryCount);
            setTimeout(() => {
              this.applyCarouselARIA(retryCount + 1);
            }, delay);
          }
          return;
        }

        carouselViewports.forEach(el => {
          if (!el.hasAttribute('role')) {
            el.setAttribute('role', 'none');
          }
        });
        carouselTracks.forEach(el => {
          if (!el.hasAttribute('role')) {
            el.setAttribute('role', 'none');
          }
        });
        this.syncProductImageCarouselInert();
      },

      /**
       * Keep off-screen product-image slides out of tab order. vue3-carousel
       * only aria-hides wrapAround clones, but each real slide has its own link.
       */
      syncProductImageCarouselInert() {
        if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
          return;
        }
        this.$el.querySelectorAll('.product-image-carousel').forEach(root => syncVueCarouselCloneInert(root));
      },

      /**
       * Check if a badge should be hidden for the current collection
       * @param {string} groupKey - Badge group (topLeft, pill, textUnderPrice)
       * @param {string} badgeKey - Specific badge identifier
       * @returns {boolean} True if badge should be hidden
       */
      isHidden(groupKey, badgeKey) {
        if (!this.badgeHideConfig || !this.resolvedCollectionId) return false;

        const group = this.badgeHideConfig[groupKey];
        if (!group || !group[badgeKey]) return false;

        const normalizedCollectionId = this.resolvedCollectionId.replace(/[\s_-]/g, '');
        return group[badgeKey].has(normalizedCollectionId);
      },

      /**
       * Choose the first visible text badge for "Text Under Price" location
       * Implements "one-of-many" selection logic
       * @param {Array} tags - Product tags to check against
       * @returns {Object|null} Badge configuration or null if all hidden
       */
      chooseTextUnderPriceBadge(tags) {
        if (!window.productBadges?.textBadge || !tags) return null;
        const badges = window.productBadges?.textBadge;
        const matchingBadges = [];
        for (const key in badges) {
          const badgeTag = badges[key]['tag'];
          const found = tags.find(element => element === badgeTag);
          if (found) {
            matchingBadges.push({
              tag: badgeTag,
              rank: badges[key]['rank'],
              color: badges[key]['color'],
              text: badges[key]['text']
            });
          }
        }
        if (matchingBadges.length === 0) return null;
        matchingBadges.sort((a, b) => a.rank - b.rank);
        for (const badge of matchingBadges) {
          const badgeKey = `text_badge_tag_${badge.rank}`;
          if (!this.isHidden('textUnderPrice', badgeKey)) {
            return {
              ...badge,
              key: badgeKey
            };
          }
        }
        return null;
      },
      getFSDataByName(data, name) {
        if (data && data.length > 0) {
          return data.find(item => item[0] === name);
        } else {
          return [];
        }
      },
      setColoObjectFromFSalt(data, avoidHandle) {
        const handle = data[1].replace('/products/', '');
        if (handle === avoidHandle) {
          return;
        }
        let images = this.getFSDataByName(data[3].att, 'Product images') || [];
        images = images[1] && Array.isArray(images[1]) ? images[1].slice(0, this.imageLookUpMax) : [];
        let tags = this.getFSDataByName(data[3].att, 'Tag');
        let productType = this.getFSDataByName(this.fsData.att, 'Type');
        let description = this.fsData.d;
        let colorData = {
          availableForSale: !data[3].iso,
          compareAtPrice: data[3].p_c && data[3].p_c > 0 ? { amount: String(data[3].p_c) } : null,
          descriptionHtml: description,
          handle: handle,
          productTitle: this.productTitle,
          images: images,
          name: data[0],
          pid: data[2],
          price: data[3].p,
          productType: productType && productType[1] ? productType[1] : '',
          tags: tags && tags[1] ? tags[1] : []
        };
        let priceData = {
          compareAtPriceMax: parseFloat(data.p_max_c ?? data[3]?.p_max_c) || 0,
          compareAtPriceMin: parseFloat(data.p_min_c ?? data[3]?.p_min_c) || 0,
          priceMax: parseFloat(data.p_max ?? data[3]?.p_max) || 0,
          priceMin: parseFloat(data.p_min ?? data[3]?.p_min) || 0,
          handle: colorData.handle
        };
        this.prices.push(priceData);
        return colorData;
      },
      setColoObjectFromFSPrimary(data) {
        const firstVariantData = data.vra[0]?.[1];
        const colorEntry = firstVariantData ? this.getFSDataByName(firstVariantData, 'Color') : null;
        const itemColorName = colorEntry?.[1]?.[0] || '';
        let colorName = this.getFSDataByName(data.att, 'Option 1 name') || [0, 'Color'];
        this.colorName = colorName && colorName[1] ? colorName[1] : 'Color';
        let images = this.getFSDataByName(data.att, 'Product images') || [];
        images = images[1] && Array.isArray(images[1]) ? images[1].slice(0, this.imageLookUpMax) : [];
        let tags = this.getFSDataByName(data.att, 'Tag');
        let productType = this.getFSDataByName(data.att, 'Type');
        let description = data.d;
        let colorData = {
          availableForSale: !data.iso,
          compareAtPrice: data.p_c && data.p_c > 0 ? { amount: String(data.p_c) } : null,
          descriptionHtml: description,
          handle: data.u.replace('/products/', ''),
          productTitle: this.productTitle,
          images: images,
          name: itemColorName,
          pid: data.id,
          price: data.p,
          productType: productType && productType[1] ? productType[1] : '',
          tags: tags && tags[1] ? tags[1] : []
        };

        let priceData = {
          compareAtPriceMax: parseFloat(data.p_max_c) || 0,
          compareAtPriceMin: parseFloat(data.p_min_c) || 0,
          priceMax: parseFloat(data.p_max) || 0,
          priceMin: parseFloat(data.p_min) || 0,
          handle: colorData.handle
        };
        this.prices.push(priceData);

        return colorData;
      },
      setupDataFromFS() {
        if (this.fsData?.att) {
          let vendorData = this.getFSDataByName(this.fsData.att, 'Vendor');
          let vendorValue = vendorData && vendorData[1] ? vendorData[1] : '';
          this.vendor = Array.isArray(vendorValue) ? vendorValue[0] || '' : vendorValue;
          this.checkVendorCollectionExists();
        }
        let mainColor = this.setColoObjectFromFSPrimary(this.fsData);
        let mainHandle = mainColor.handle;
        this.colors.push(mainColor);
        if (this.fsData.alt) {
          this.fsData.alt.forEach(color => {
            let colorData = this.setColoObjectFromFSalt(color, mainHandle);
            if (colorData) {
              this.colors.push(colorData);
            }
          });
        }
        this.colorsCount = this.colors.length;
        this.updateSwatchCountBasedOnGridSize();
        this.fetchRatingIfEnabled();
        this.markTileReady();

        this.$nextTick(() => {
          this.$nextTick(() => {
            if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
              emitter.emit('fs-products-loaded', true);
              return;
            }

            const images = this.$el.querySelectorAll('.product-grid-item__image');

            if (!images.length) {
              emitter.emit('fs-products-loaded', true);
              return;
            }

            const allLoaded = Array.from(images).every(img => img.complete);
            if (allLoaded) {
              emitter.emit('fs-products-loaded', true);
              return;
            }

            const imageLoadPromises = Array.from(images).map(img => {
              if (img.complete) return Promise.resolve();
              return new Promise(resolve => {
                img.onload = resolve;
                img.onerror = resolve;
              });
            });

            Promise.all(imageLoadPromises).then(() => {
              emitter.emit('fs-products-loaded', true);
            });
          });
        });
      },
      getClientWidth() {
        const width = window.siteGlobals.device;
        if (width == 'mobile-size') {
          return 'mobile-size';
        } else if (width == 'tablet-size') {
          return 'tablet-size';
        } else {
          return 'desktop-size';
        }
      },
      checkSoldOutBadgeStatus(tags) {
        let showSoldout = this.sellOutSettings;
        if (this.soldOutTag) {
          const found = tags.find(element => element == this.soldOutTag);
          if (found) {
            showSoldout = false;
          }
        }
        return showSoldout;
      },
      checkReminderTag(tags) {
        let showReminder = false;
        if (this.setReminderTag != '') {
          const found = tags.find(element => element == this.setReminderTag);
          if (found) {
            showReminder = true;
          }
        }
        return showReminder;
      },
      colorHasPriceRange(handle) {
        const entry = this.prices.find(p => p.handle === handle);
        if (!entry) return false;
        const priceMin = parseFloat(entry.priceMin) || 0;
        const priceMax = parseFloat(entry.priceMax) || 0;
        return priceMin > 0 && priceMax > 0 && priceMin !== priceMax;
      },
      compareAtRangeClass(handle) {
        const entry = this.prices.find(p => p.handle === handle);
        if (!entry) return 'hide_compare_at_price_range';
        const compareAtPriceMin = parseFloat(entry.compareAtPriceMin) || 0;
        if (compareAtPriceMin === 0) {
          return 'hide_compare_at_price_range';
        }
        return ' sale_color_range compare_at_range_crossed_out';
      },
      getPriceRangeMinByHandle(handleName) {
        let priceMin = 0;
        this.prices.forEach(item => {
          if (item.handle === handleName) {
            priceMin = item.priceMin;
          }
        });
        return this.convertToCurrency(priceMin);
      },
      getPriceRangeMaxByHandle(handle) {
        let priceMax = 0;
        this.prices.forEach(item => {
          if (item.handle === handle) {
            priceMax = item.priceMax;
          }
        });
        return this.convertToCurrency(priceMax);
      },
      getCompareAtPriceRangeMinByHandle(handleName) {
        let compareAtPriceMin = 0;
        this.prices.forEach(item => {
          if (item.handle === handleName) {
            compareAtPriceMin = item.compareAtPriceMin;
          }
        });
        return this.convertToCurrency(compareAtPriceMin);
      },
      getCompareAtPriceRangeMaxByHandle(handle) {
        let compareAtPriceMax = 0;
        this.prices.forEach(item => {
          if (item.handle === handle) {
            compareAtPriceMax = item.compareAtPriceMax;
          }
        });
        return this.convertToCurrency(compareAtPriceMax);
      },
      trackClick(itemId) {
        if (typeof ElevarDataLayer !== 'undefined' && this.searchTerm != '') {
          window.handleSearchResultsClick(itemId);
        }
      },
      onProductImageClick(pid) {
        this.reportClickView(pid, this.productIndex);
        this.trackClick(pid);
      },
      HandleColorlessProducts(itemIndex, itemPID) {
        if (this.productIsFragrance) {
          if (itemIndex === 0) {
            return true;
          }
          return false;
        }
        if (this.activePid === itemPID) {
          return true;
        }
        return false;
      },
      checkSwatchesByProductType(colors) {
        let result = true;
        colors.forEach(color => {
          if (color.productType == 'Fragrance' || color.productType == 'Candles' || color.productType == 'Diffusers') {
            result = false;
          }
        });
        this.productIsFragrance = !result;
        return result;
      },
      getCurrentPage() {
        let params = new URL(document.location).searchParams;
        let currentPageParam = params.get('current');
        return currentPageParam;
      },
      handleize(str) {
        return str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      },
      async checkVendorCollectionExists() {
        if (!this.addVendorLink || !this.vendor || typeof this.vendor !== 'string') return;
        const handle = this.handleize(this.vendor);
        window._vendorCollectionCache = window._vendorCollectionCache || {};
        if (handle in window._vendorCollectionCache) {
          this.vendorCollectionExists = window._vendorCollectionCache[handle];
          return;
        }
        try {
          const response = await fetch(window.theme.routes.root_url + 'collections/' + handle + '.json', { method: 'HEAD' });
          const exists = response.ok;
          window._vendorCollectionCache[handle] = exists;
          this.vendorCollectionExists = exists;
        } catch {
          window._vendorCollectionCache[handle] = false;
          this.vendorCollectionExists = false;
        }
      },
      getColorSwatchImages(color) {
        //console.log('color', color);
        const baseUrl = window.cdn + this.handleize(color) + '.png';
        const sizedUrl = this.buildSizedImageUrl(baseUrl, 120);
        return 'background-image:url(' + sizedUrl + ')';
      },
      getImageSwatchImages(color) {
        if (this.useFsProductData !== 'true') {
          let imageName = color.images.find(image => {
            const imgUrl = image?.node?.url;
            return imgUrl.includes(this.productImageName) || imgUrl.includes(this.swatchSuffix);
          })?.node?.url;

          if (!imageName) {
            imageName = color.images[0]?.node?.url || this.assetUrl + color.swatch;
          }
          return imageName;
        } else {
          let imageName = color.images.find(image => {
            const imgUrl = image;
            return imgUrl.includes(this.productImageName) || imgUrl.includes(this.swatchSuffix);
          });

          if (!imageName) {
            imageName = color.images[0] || this.assetUrl + color.swatch;
          }
          return imageName;
        }
      },
      resolveImageUrl(imageUrl) {
        return this.useFsProductData == 'true' ? imageUrl : imageUrl?.node?.url;
      },
      handleImageUrl(imageUrl) {
        return buildSizedImageUrl(this.resolveImageUrl(imageUrl), 700);
      },
      productImageSrcset(imageUrl) {
        const url = this.resolveImageUrl(imageUrl);
        if (!url) return '';
        return [400, 600, 800, 1000, 1200, 1600].map(w => `${buildSizedImageUrl(url, w)} ${w}w`).join(', ');
      },
      productImageSizes() {
        const cols = Number(this.gridLarge) || 4;
        const colsSmall = Number(this.gridSmall) || 2;
        const desktopMin = (window.theme?.sizes?.medium || 767) + 1;
        return `(min-width: ${desktopMin}px) calc(100vw / ${cols}), calc(100vw / ${colsSmall})`;
      },
      buildSizedImageUrl(url, width) {
        return buildSizedImageUrl(url, width);
      },
      getImageSwatchSrcSet(color) {
        const base = this.getImageSwatchImages(color);
        return buildResponsiveSrcset(base, 60);
      },
      handleSlideStart(emitPID) {
        this.$emit('currentCarouselSlideStart', emitPID);
        if (!this.isProgrammaticSlide) {
          this.revealMobilePaginationDots();
        }
      },
      handleSlideEnd() {
        if (this.mobileShowPaginationDots) this.hideMobileDotsOnPageScroll();
        this.syncProductImageCarouselInert();
      },
      revealMobilePaginationDots() {
        if (this.getClientWidth() !== 'mobile-size') return;
        this.resetOtherSwipedTile();
        tileShowingMobileDots = this;
        this.stopHidingMobileDotsOnPageScroll();
        this.mobileShowPaginationDots = true;
      },
      resetOtherSwipedTile() {
        if (tileShowingMobileDots && tileShowingMobileDots !== this) tileShowingMobileDots.hideMobileDotsAndReset();
      },
      onCarouselDrag() {
        this.tileTouchDragged = true;
        this.resetOtherSwipedTile();
      },
      onTileTouchStart() {
        this.tileTouchActive = true;
        this.tileTouchDragged = false;
        this.tileTouchStartScrollY = Math.max(0, window.scrollY);
      },
      onTileTouchEnd() {
        if (!this.tileTouchActive) return;
        this.tileTouchActive = false;
        if (!this.mobileShowPaginationDots) return;
        const drift = Math.abs(Math.max(0, window.scrollY) - this.tileTouchStartScrollY);
        if (!this.tileTouchDragged && drift >= SWIPE_VERTICAL_DRIFT_TOLERANCE_PX) {
          this.hideMobileDotsAndReset();
          return;
        }
        if (this.mobileDotsScrollAnchor !== null) this.mobileDotsScrollAnchor = Math.max(0, window.scrollY);
      },
      hideMobileDotsAndReset() {
        if (tileShowingMobileDots === this) tileShowingMobileDots = null;
        this.stopHidingMobileDotsOnPageScroll();
        this.mobileShowPaginationDots = false;
        this.resetCarousel();
      },
      hideMobileDotsOnPageScroll() {
        this.stopHidingMobileDotsOnPageScroll();
        this.mobileDotsScrollAnchor = Math.max(0, window.scrollY);
        document.addEventListener('theme:scroll', this.onPageScrollWhileMobileDotsShown);
      },
      stopHidingMobileDotsOnPageScroll() {
        this.mobileDotsScrollAnchor = null;
        document.removeEventListener('theme:scroll', this.onPageScrollWhileMobileDotsShown);
      },
      onPageScrollWhileMobileDotsShown(e) {
        // Resetting mid-gesture discards vue3-carousel's drag, so scroll resets wait for the finger to lift
        if (this.tileTouchActive) return;
        const position = Math.max(0, e.detail?.position ?? window.scrollY);
        if (Math.abs(position - this.mobileDotsScrollAnchor) < SWIPE_VERTICAL_DRIFT_TOLERANCE_PX) return;
        this.hideMobileDotsAndReset();
      },
      handleMouseLeave(e) {
        if (window.siteGlobals.device != 'mobile-size') {
          const related = e?.relatedTarget;
          if (related && this.$el?.contains(related)) return;
          this.isHovering = false;
          this.resetCarousel();
        }
      },
      handleMouseOver() {
        if (window.siteGlobals.device != 'mobile-size') {
          this.isHovering = true;
          this.shouldAutoPlay = this.slideTimeOut;
        }
      },
      getIntentColor() {
        return this.colors?.find(c => c.pid === this.activePid) || this.colors?.[0] || null;
      },
      getPdpImageWidths() {
        const root = document.getElementById('fs-collection-products');
        const desktop = Number(window.pdp_desktop_image_width || root?.getAttribute('data-pdp-desktop-image-width') || window.theme?.pdpDesktopImageWidth);
        const mobile = Number(window.pdp_mobile_image_width || root?.getAttribute('data-pdp-mobile-image-width') || window.theme?.pdpMobileImageWidth);
        return { desktop, mobile };
      },
      // A cursor crossing a dense grid fires mouseenter on every tile it passes.
      // Waiting for the pointer to settle keeps the sweep from issuing a GraphQL
      // warm and an LCP-sized image download per tile crossed.
      onProductIntentStart() {
        clearTimeout(this.intentDwellTimer);
        this.intentDwellTimer = setTimeout(this.onProductIntent, 120);
      },
      onProductIntent() {
        const item = this.getIntentColor();
        if (!item) return;
        const isProductPage = String(window.siteGlobals?.pageType || '').toLowerCase() === 'product';
        if (!isProductPage && this.productTitle) {
          productStore.warmFromPlp({ productTitle: this.productTitle, productHandle: item.handle, countryCode: this.countryCode || window.Shopify?.country });
        }
        this.prefetchPdpLcpImage(item);
      },
      onProductPointerDown(e) {
        // pointerdown precedes the swatch's own click, so activePid is still the old
        // color here. setActiveColor fires the intent once it has been updated.
        if (e.target.closest('.swatch_button_wrapper')) return;
        const link = e.target.closest('a');
        if (link && !/\/products\//.test(link.getAttribute('href') || '')) return;
        // A tap or click is unambiguous intent, so skip the dwell entirely.
        clearTimeout(this.intentDwellTimer);
        this.onProductIntent();
      },
      onProductIntentEnd() {
        clearTimeout(this.intentDwellTimer);
        const country = this.countryCode || window.Shopify?.country;
        if (!this.productTitle || !country) return;
        productStore.cancelWarmIfNotStarted(`${this.productTitle}::${country}`);
      },
      prefetchPdpLcpImage(item) {
        const raw = this.resolveImageUrl(item?.images?.[0]);
        if (!raw) return;
        const medium = window.theme?.sizes?.medium;
        const isMobile = typeof medium === 'number' ? window.innerWidth <= medium : false;
        const { desktop, mobile } = this.getPdpImageWidths();
        const width = isMobile ? mobile : desktop;
        if (!width) return;
        // Must match the URL the PDP's LCP element requests, which is the eager
        // SSR image in sections/product.liquid: pdp_mobile_image_width * 2 on
        // mobile, pdp_desktop_image_width on desktop. The Vue gallery swaps in a
        // different mobile URL after hydration, but that is not the LCP, so
        // prefetching it would warm the swap and leave the LCP uncached.
        const sized = buildSizedImageUrl(raw, isMobile ? mobile * 2 : desktop);
        if (!sized) return;
        const PREFETCH_ID = 'gm-pdp-lcp-prefetch';
        let link = document.getElementById(PREFETCH_ID);
        if (link?.href === sized) return;
        if (!link) {
          link = document.createElement('link');
          link.id = PREFETCH_ID;
          link.rel = 'prefetch';
          link.as = 'image';
          document.head.appendChild(link);
        }
        link.href = sized;
      },
      resetCarousel() {
        const mainCarousel = this.$refs.mainCarousel;
        this.shouldAutoPlay = 0;

        if (mainCarousel) {
          this.isProgrammaticSlide = true;
          if (Array.isArray(mainCarousel)) {
            mainCarousel.forEach(el => el.slideTo(0, true));
          } else {
            mainCarousel.slideTo(0, true);
          }
          this.isProgrammaticSlide = false;
        }
      },
      async triggerPeekABoo() {
        if (!this.enableMobilePeekABoo) return;
        if (peekABooFired || window.siteGlobals?.device !== 'mobile-size') return;
        if ((this.colors?.[0]?.images?.length ?? 0) <= 1) return;
        await new Promise(resolve => setTimeout(resolve, 800));
        const ref = this.$refs.mainCarousel;
        const carouselVm = Array.isArray(ref) ? ref[0] : ref;
        const carouselEl = carouselVm?.$el;
        if (!carouselEl) return;
        const track = carouselEl.querySelector('.carousel__track');
        const viewport = carouselEl.querySelector('.carousel__viewport');
        if (!track || !viewport) return;
        peekABooFired = true;
        const w = viewport.getBoundingClientRect().width;
        const matrix = window.getComputedStyle(track).transform;
        const x = matrix === 'none' ? 0 : new DOMMatrixReadOnly(matrix).m41;
        const slides = carouselEl.querySelectorAll('.carousel__slide');
        const nextSlide = slides[Math.round(Math.abs(x) / w) + 1] || null;
        if (nextSlide) nextSlide.classList.add('peek-target');
        this.isPeeking = true;
        await this.$nextTick();
        try {
          await track.animate([{ transform: `translateX(${x}px)`, easing: 'ease-in-out' }, { transform: `translateX(${x - w * 0.33}px)`, offset: 0.35, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }, { transform: `translateX(${x}px)` }], { duration: 1400, fill: 'none' }).finished;
        } finally {
          if (nextSlide) nextSlide.classList.remove('peek-target');
          this.isPeeking = false;
          track.getAnimations?.().forEach(anim => anim.cancel());
          await this.$nextTick();
          if (typeof carouselVm.restartCarousel === 'function') {
            carouselVm.restartCarousel();
          }
          await this.$nextTick();
          // WAAPI can leave the track out of sync with vue3-carousel's inline transform; re-apply slide 0
          // without motion so translate matches wrapAround clones.
          if (typeof carouselVm.slideTo === 'function') {
            this.isProgrammaticSlide = true;
            try {
              carouselVm.slideTo(0, true);
            } finally {
              await this.$nextTick();
              this.isProgrammaticSlide = false;
            }
          }
        }
      },
      updateSwatchCountBasedOnGridSize() {
        this.$nextTick(() => {
          this.calculateMaxVisibleSwatches();
          this.resetCarousel();
          this.$nextTick(() => {
            const sw = this.$refs.swatchCarousel;
            if (sw && typeof sw.restartCarousel === 'function') {
              sw.restartCarousel();
            }
          });
        });
      },
      calculateMaxVisibleSwatches() {
        if (!this.$el || typeof this.$el.querySelector !== 'function') {
          return;
        }

        const wrapper = this.$el.querySelector('.swatch_button_wrapper.image_swatches');
        if (!wrapper) {
          return;
        }

        const containerWidth = wrapper.offsetWidth;
        const firstSwatchBtn = wrapper.querySelector('.swatch-spacer .swatch-anchor');
        const swatchWidth = firstSwatchBtn?.offsetWidth;
        if (!containerWidth || !swatchWidth || swatchWidth <= 0) {
          return;
        }

        this.itemsToShow = Math.max(1, Math.floor(containerWidth / swatchWidth));
        this.itemsToScroll = this.itemsToShow;
      },
      alignSwatchCarouselToIndex(index) {
        if (!this.swatchSuffix || this.hideSwatches === true || this.productSwatchesHidden) {
          return;
        }
        if (!this.$el || typeof this.$el.querySelector !== 'function') {
          return;
        }
        this.calculateMaxVisibleSwatches();
        const count = this.colors.length;
        if (count === 0 || index < 0 || index >= count) {
          return;
        }
        const n = Math.max(1, this.itemsToShow);
        if (count <= n) {
          this.currentSlide = 0;
          return;
        }
        const maxSlide = Math.max(0, Math.ceil(count - n));
        let start = this.currentSlide;
        if (index < start) {
          start = index;
        } else if (index > start + n - 1) {
          start = index - n + 1;
        }
        this.currentSlide = Math.min(Math.max(0, start), maxSlide);
      },
      areThereLessThan5Swatches() {
        if (this.colors.length < this.gridSizeBasedSwatches) {
          this.lessThan5Swatches = true;
        }
      },
      areThereLessThan3Swatches() {
        if (this.colors.length <= 3) {
          this.lessThan3Swatches = true;
        }
      },
      setCounterMessage(numb) {
        if (numb == 1) {
          return '1 ' + this.colorName;
        } else {
          return numb + ' ' + this.colorName + 's';
        }
      },
      setSwatchesToShow(numb) {
        if (numb > 6) {
          return 6;
        } else {
          return numb;
        }
      },
      setProductPDPLink(handle) {
        if (this.collectionHandle) {
          return window.theme.routes.root_url + 'collections/' + this.collectionHandle + '/products/' + handle;
        } else {
          return window.theme.routes.root_url + 'products/' + handle;
        }
      },
      isActive(ind) {
        if (ind == 0) {
          return 'product-grid-item__image-wrapper is-active';
        } else {
          return 'product-grid-item__image-wrapper';
        }
      },
      shouldDisplayProduct() {
        let display = false;
        this.colors.forEach(color => {
          if (color.pid === this.activePid) {
            display = true;
          }
        });
        return display;
      },
      ShouldDisplayComparePrice(compare, price) {
        if (compare && compare.amount && parseFloat(compare.amount) > parseFloat(price)) {
          return true;
        }
        return false;
      },
      getSwatchSwitchPosition() {
        if (this.fsProductPosition) return this.fsProductPosition;
        if (typeof this.productIndex === 'number') return this.productIndex + 1;
        if (typeof this.slideIndex === 'number') return this.slideIndex + 1;
        return undefined;
      },
      setActiveColor(pid, index) {
        const previousActivePid = this.activePid;
        this.activePid = pid;
        if (String(pid) !== String(this.pid) && String(pid) !== String(previousActivePid)) {
          reportProductSwatchSwitch({ productID: pid, sourceProductID: this.pid, position: this.getSwatchSwitchPosition() });
        }
        if (this.useFsProductData == 'true') {
          this.resetCarousel();
        }
        if (String(pid) !== String(previousActivePid)) {
          clearTimeout(this.intentDwellTimer);
          this.onProductIntent();
        }
        this.$nextTick(() => {
          this.alignSwatchCarouselToIndex(index);
        });
      },
      onSwatchCarouselModelValue(val) {
        this.currentSlide = val;
      },
      convertToCurrency(str) {
        let dollarUS = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currencyCode
        });
        let price = dollarUS.format(str).replace('.00', '');
        if (price.includes('CA')) {
          price = price.replace('CA', '');
          price = price + ' CAD';
        }
        return price;
      },
      getProductMasterIDfromBase(gid) {
        return gid.replace('gid://shopify/Product/', '');
      },
      getActiveClass(ppid) {
        if (ppid === this.activePid) {
          return 'swatch__label is-active';
        } else {
          return 'swatch__label';
        }
      },
      markTileReady() {
        if (this.tileReadyEmitted) return;
        this.tileReadyEmitted = true;
        this.$emit('tile-ready', this.pid);
      },
      getProductDataById() {
        storefront
          .request(queries.productMasterByIds, {
            variables: {
              query: 'id:' + this.pid,
              countryIso2: this.countryCode
            }
          })
          .then(response => {
            const productMasters = response.data.products.edges[0]?.node;
            if (!productMasters || this.productTitle !== productMasters.title) {
              this.markTileReady();
              return;
            }

            this.processProductData([productMasters]);
          })
          .then(() => {
            this.$nextTick(() => {
              if (!this.$el || typeof this.$el.querySelectorAll !== 'function') {
                emitter.emit('fs-products-loaded', false);
                return;
              }

              const images = this.$el.querySelectorAll('.product-grid-item__image');

              if (!images.length) {
                emitter.emit('fs-products-loaded', false);
                return;
              }

              const imageLoadPromises = Array.from(images).map(img => {
                if (img.complete) return Promise.resolve();
                return new Promise(resolve => {
                  img.onload = resolve;
                  img.onerror = resolve;
                });
              });

              Promise.all(imageLoadPromises).then(() => {
                emitter.emit('fs-products-loaded', true);
              });
            });
          })
          .catch(error => {
            console.error('ProductListItem: Error fetching product data:', {
              error: error?.message || error,
              stack: error?.stack,
              response: error?.response,
              fullError: error
            });
            this.markTileReady();
          });
      },
      getProductData() {
        storefront
          .request(queries.productVariantsByTitle, {
            variables: {
              query: buildProductTitleSearchQuery(this.productTitle),
              countryIso2: this.countryCode,
              images: this.imageLookUpMax,
              totalProduct: this.productsByTitleLookup
            }
          })
          .then(response => {
            const productMasters = response.data.products.edges.map(edge => edge.node);
            this.processProductData(productMasters);
          })
          .catch(error => {
            console.error('ProductListItem: Error fetching product data:', {
              error: error?.message || error,
              stack: error?.stack,
              response: error?.response,
              fullError: error
            });
            this.markTileReady();
          });
      },
      processProductData(productMasters) {
        const colorSet = new Set();
        const result = productMasters.reduce(
          (acc, node) => {
            if (!node || this.handleize(this.productTitle) !== this.handleize(node.title)) {
              return acc;
            }

            const {
              handle,
              id,
              descriptionHtml,
              images: { edges: images },
              variants: { edges: variants },
              tags,
              totalInventory,
              productType,
              vendor
            } = node;

            this.vendor = vendor;
            this.checkVendorCollectionExists();
            const pid = this.getProductMasterIDfromBase(id);

            let priceMin = Infinity,
              priceMax = -Infinity;
            let compareAtPriceMin = Infinity,
              compareAtPriceMax = -Infinity;

            const variantDataList = variants.map(({ node: variantNode }) => {
              const {
                price: { amount },
                compareAtPrice
              } = variantNode;
              const price = parseFloat(amount);
              const compareAtPriceAmount = compareAtPrice ? parseFloat(compareAtPrice.amount) : null;

              priceMin = Math.min(priceMin, price);
              priceMax = Math.max(priceMax, price);

              if (compareAtPriceAmount !== null) {
                compareAtPriceMin = Math.min(compareAtPriceMin, compareAtPriceAmount);
                compareAtPriceMax = Math.max(compareAtPriceMax, compareAtPriceAmount);
              }

              const selectedOptions = variantNode.selectedOptions;
              const optionData = selectedOptions.reduce((optionsAcc, option, index) => {
                if (index === 0) {
                  if (option.name === 'Color') this.isColorOption = true;
                  this.colorName = option.name || 'Color';
                  if (option.value === 'Default Title') this.hideColorOption = 1;

                  if (!colorSet.has(option.value)) {
                    colorSet.add(option.value);
                    acc.colors.push({
                      name: option.value,
                      handle,
                      title: this.productTitle,
                      descriptionHtml,
                      images,
                      pid,
                      productType,
                      price,
                      compareAtPrice,
                      availableForSale: variantNode.availableForSale,
                      tags,
                      totalInventory
                    });
                    this.optionOneName = option.name;
                  }
                  optionsAcc.color = option.value;
                }
                return optionsAcc;
              }, {});

              return {
                handle,
                availableForSale: variantNode.availableForSale,
                price,
                compareAtPrice,
                color: optionData.color || '',
                size: '',
                width: '',
                quantityAvailable: variantNode.quantityAvailable,
                image: variantNode.image?.url || '',
                sku: variantNode.sku
              };
            });

            acc.variants.push(...variantDataList);
            acc.prices.push({
              handle,
              priceMin,
              priceMax,
              compareAtPriceMin: compareAtPriceMin === Infinity ? 0 : compareAtPriceMin,
              compareAtPriceMax: compareAtPriceMax === -Infinity ? 0 : compareAtPriceMax
            });

            return acc;
          },
          {
            variants: [],
            colors: [],
            prices: []
          }
        );

        this.variants = result.variants;
        this.colors = result.colors;
        this.colorsCount = result.colors.length;

        this.prices = result.prices;

        this.updateSwatchCountBasedOnGridSize();
        this.areThereLessThan5Swatches();
        this.areThereLessThan3Swatches();
        this.fetchRatingIfEnabled();
        this.markTileReady();
      },
      async fetchRatingIfEnabled() {
        if (!this.showRating) return;
        try {
          const handle = this.colors?.[0]?.handle;
          if (!handle) return;
          const map = await fetchRatingsForHandles(storefront, queries, [handle], this.countryCode);
          const data = map.get(handle);
          if (data) {
            this.rating = data.rating ?? 0;
            this.ratingCount = data.count ?? null;
          }
        } catch (e) {
          console.error('ProductListItem: Error fetching rating data:', e);
          this.rating = 0;
          this.ratingCount = null;
        }
      },
      reportClickView(productID, index) {
        whenFastSimonReady(() => {
          if (this.resolvedCollectionId !== 'undefined' && this.resolvedCollectionId !== undefined && this.resolvedCollectionId !== '' && this.bodyID !== 'search-results') {
            this.reportProductViewCollection(productID, index);
          } else if (this.bodyID === 'search-results') {
            this.reportProductViewSearch(productID, index);
          }
        });
      },
      reportProductViewCollection(productID, index) {
        whenFastSimonReady(() => {
          let indexUpdated = index + 1;
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.CollectionProductClicked,
            data: {
              collectionID: this.resolvedCollectionId,
              productID: productID,
              position: indexUpdated,
              query: this.collectionHandle
            }
          });
        });
      },
      reportQuickViewClickedWidget(productID) {
        if (!this.fsWidgetId) return;
        whenFastSimonReady(() => {
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.QuickViewClickedWidget,
            data: {
              widget_id: this.fsWidgetId,
              productID: String(productID),
              position: this.fsProductPosition
            }
          });
        });
      },
      reportProductViewSearch(productID, index) {
        whenFastSimonReady(() => {
          let indexUpdated = index + 1;
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.SerpProductClicked,
            data: {
              query: this.searchTerm,
              productID: productID,
              position: indexUpdated
            }
          });
        });
      },
      templateType() {
        if (this.bodyClasses.includes('template-page') || this.bodyClasses.includes('template-collection') || this.bodyID === 'search-results') {
          if (window.siteGlobals.device == 'mobile-size') {
            this.mouseDrag = false;
            this.touchDrag = this.enableMobileImageSwipe;
          } else {
            this.mouseDrag = true;
            this.touchDrag = false;
          }
        } else {
          this.mouseDrag = false;
          this.touchDrag = false;
        }
        this.triggerPeekABoo();
      },
      checkExcludedProductTypes(itemProductType) {
        if (itemProductType && this.productTypesExcluded && this.productTypesExcluded.includes(itemProductType)) {
          this.productSwatchesHidden = true;
        } else {
          this.productSwatchesHidden = false;
        }
      },
      triggerKlaviyoPopup() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', this.reminderFormIDPopup]);
      },
      handleImageLoad() {
        emitter.emit('product-slide-loaded', this.slideIndex);
      },
      getQuickviewModalTemplate(pid) {
        return `<div class="drawer drawer--right quickview__modal" data-quickview-modal data-form-holder id="${pid}" aria-hidden="true"><div class="drawer__content" data-product-quickview-ajax></div><span class="drawer__underlay" data-micromodal-close tabindex="-1"><span class="drawer__underlay__fill"></span><span class="drawer__underlay__blur"></span></span></div>`;
      },
      async fetchCollectionUrl(collectionGid, targetProperty) {
        const url = await productStore.fetchCollectionUrl(collectionGid);
        this[targetProperty] = url;
      },
      extractGidFromUrl(urlOrGid) {
        if (!urlOrGid) return null;
        if (urlOrGid.startsWith('gid://shopify/Collection/')) return urlOrGid;
        const gidMatch = urlOrGid.match(/gid:\/\/shopify\/Collection\/\d+/);
        return gidMatch ? gidMatch[0] : null;
      }
    }
  };
</script>

<template>
  <!-- Product grid item -->
  <div class="product-grid-item" v-if="shouldDisplayProduct()" :id="'product-tile-' + pid" :data-pid="this.productIndex" @mouseenter="onProductIntentStart" @mouseleave="onProductIntentEnd" @pointerdown="onProductPointerDown">
    <template v-for="(item, index) in colors" :key="'image' + index + '-color-' + item.handle + getCurrentPage()">
      <!-- Product images -->
      <div :class="'product-grid-item__container product-grid-item__content hide-me-' + hideMe + (item.images?.length > 1 && showPaginationDots ? ' show-pagination-dots' : '')" v-if="HandleColorlessProducts(index, item.pid)">
        <ProductListTopLeftBadge :tags="item.tags" :collectionId="resolvedCollectionId" :badgeHideConfig="badgeHideConfig" />
        <div class="product-grid-carousel-wrap" v-if="this.disableSlider !== true && item.images && item.images.length > 1" :class="{ 'is-peeking': isPeeking }" @touchstart.passive="onTileTouchStart" @touchend.passive="onTileTouchEnd" @touchcancel.passive="onTileTouchEnd">
          <carousel :autoplay="shouldAutoPlay" :class="['product-image-carousel', { 'product-image-carousel--no-drag': !touchDrag }]" :items-to-show="1" :items-to-scroll="1" :mouse-drag="mouseDrag" :touch-drag="touchDrag" :wrapAround="true" :ignoreAnimations="true" @mouseleave="handleMouseLeave($event)" @mouseover="handleMouseOver" @slide-start="handleSlideStart(item.pid)" @slide-end="handleSlideEnd" @drag="onCarouselDrag" ref="mainCarousel" @init="(templateType(), $emit('countCarouselsLoaded'), checkExcludedProductTypes(item.productType), $nextTick(() => syncProductImageCarouselInert()))">
            <slide v-for="(image, imageIndex) in item.images" :key="item.pid + 'image' + imageIndex + '-color-image' + item.handle">
              <a class="product-grid-item__image-link" :href="setProductPDPLink(item.handle)" @click="onProductImageClick(item.pid)">
                <div class="product-grid-item__slide-hit">
                  <img :src="handleImageUrl(image)" :srcset="productImageSrcset(image)" :sizes="productImageSizes()" :alt="`${productTitle}${item.name ? ' in ' + item.name : ''} product image`" class="tw-block tw-overflow-hidden tw-object-cover tw-w-full tw-h-full product-grid-item__image" width="500" :height="intrinsicImageHeight" @load="handleImageLoad" />
                </div>
              </a>
            </slide>
            <template #addons>
              <pagination v-if="disableSlider !== true" />
            </template>
          </carousel>
          <ProductListBottomPillBadge :tags="item.tags" :collectionId="resolvedCollectionId" :badgeHideConfig="badgeHideConfig" />
        </div>
        <div class="product-grid-single-wrap" v-else-if="item.images && item.images.length">
          <a class="product-grid-item__image-link" :href="setProductPDPLink(item.handle)" @click="onProductImageClick(item.pid)">
            <img :src="handleImageUrl(item?.images[0])" :srcset="productImageSrcset(item?.images[0])" :sizes="productImageSizes()" :alt="`${productTitle}${item.name ? ' in ' + item.name : ''} product image`" class="tw-block tw-overflow-hidden tw-object-cover tw-w-full tw-h-full product-grid-item__image" width="500" :height="intrinsicImageHeight" @load="handleImageLoad" />
          </a>
          <ProductListBottomPillBadge :tags="item.tags" :collectionId="resolvedCollectionId" :badgeHideConfig="badgeHideConfig" />
        </div>
        <div class="product__badge product__badge--sold pdp-badge gt-badge" v-if="item.totalInventory == 0 && checkSoldOutBadgeStatus(item.tags) == 'true'">Sold Out</div>

        <!-- Quickview - one instance per tile on the active color only -->
        <product-quickview v-if="showQuickviewMounted && item.pid === activePid" :data-quickview="item.pid" :class="['product-grid-item__quickview-root', { 'product-grid-item__actions': shouldShowQuickviewIcon && !hasPlpQuickviewIcon }]">
          <div :data-quickview-holder="item.pid" data-add-action-wrapper>
            <div v-if="shouldShowQuickviewIcon && hasPlpQuickviewIcon" :class="['product-grid-item__mobile-quickview-wrap', 'product-grid-item__plp-quickview-wrap', { 'kam-plp-quickview': shouldShowMobilePlpQuickview || shouldShowDesktopPlpQuickview, 'kam-mobile-plp-quickview': shouldShowMobilePlpQuickview, 'kam-desktop-plp-quickview': shouldShowDesktopPlpQuickview, 'product-grid-item__plp-quickview-wrap--has-image-swatches': hasDesktopPlpImageSwatches, 'kam-crosssell-quickview product-grid-item__mobile-quickview-wrap--crosssell': isCrosssellQuickviewIcon }]">
              <button type="button" class="product-grid-item__mobile-quickview-btn" :[`data-popup-${item.pid}`]="item.handle" :aria-label="plpQuickviewAriaLabel" @click.stop="reportQuickViewClickedWidget(item.pid)">
                <span class="btn-state-ready product-grid-item__mobile-quickview-btn__ready">
                  <img :src="plpQuickviewIconUrl" class="product-grid-item__mobile-quickview-btn__icon-img" :alt="plpQuickviewIconAlt" loading="lazy" />
                </span>
                <span class="btn-state-loading" aria-hidden="true">
                  <svg height="18" width="18" class="svg-loader">
                    <circle r="7" cx="9" cy="9"></circle>
                    <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                  </svg>
                </span>
              </button>
            </div>
            <button v-else-if="shouldShowQuickviewIcon" type="button" class="product-grid-item__btn gt-btn" :[`data-popup-${item.pid}`]="item.handle" :aria-label="plpQuickviewAriaLabel" @click.stop="reportQuickViewClickedWidget(item.pid)">
              <span class="gt-btn btn-state-ready">{{ plpQuickviewAriaLabel }}</span>
              <span class="btn-state-loading" aria-hidden="true">
                <svg height="18" width="18" class="svg-loader">
                  <circle r="7" cx="9" cy="9"></circle>
                  <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                </svg>
              </span>
            </button>
            <component :is="'script'" data-quickview-modal-template type="text/x-template" v-html="getQuickviewModalTemplate(item.pid)"></component>
          </div>
        </product-quickview>
      </div>

      <!-- Product text details -->
      <div class="product__grid__info text-left" :class="{ 'no-swatches': !hasVisibleSwatches }" v-if="HandleColorlessProducts(index, item.pid)">
        <!-- Color swatches -->
        <div class="swatch_button_wrapper color_swatches" :class="`${swatchConfig.device.replace('-size', '')}-swatch-limit`" v-if="hideSwatches != true && checkSwatchesByProductType(colors) && !swatchSuffix && !productSwatchesHidden && getClientWidth() === swatchConfig.device" role="radiogroup" aria-label="Color options">
          <div class="swatch__button" role="none">
            <div v-for="(item, index) in visibleColors" :key="'image' + index + '-swatch-' + item.name" class="swatch-spacer" role="none">
              <button type="button" :class="getActiveClass(item.pid)" :style="getColorSwatchImages(item.name)" @click="setActiveColor(item.pid, index)" v-if="index < swatchConfig.limit" role="radio" :aria-checked="activePid == item.pid ? 'true' : 'false'">
                <span v-html="item.name" class="visually-hidden"></span>
              </button>
              <span v-if="index === swatchConfig.limit && remainingColorsCount > 0" class="gt-p__small swatch-anchor plp-mini-swatch-count">+{{ remainingColorsCount }}</span>
            </div>
          </div>
        </div>

        <div class="plp-color-count gt-p__small" v-html="setCounterMessage(colors.length)" v-if="hideSwatches != true && checkSwatchesByProductType(colors) && !swatchSuffix && !productSwatchesHidden && colors.length > 1 && swatchConfig.limit < 1 && getClientWidth() === swatchConfig.device"></div>

        <!-- Image swatches -->
        <div class="swatch_button_wrapper image_swatches" :class="lessThan5Swatches ? 'smallSwatchesPadding' : ''" role="radiogroup" aria-label="Color options" v-if="hideSwatches != true && this.swatchSuffix && !this.productSwatchesHidden">
          <carousel ref="swatchCarousel" snapAlign="start" :class="lessThan5Swatches ? 'smallSwatchesOl' : ''" :items-to-scroll="itemsToScroll" :items-to-show="itemsToShow" :modelValue="currentSlide" role="none" @update:modelValue="onSwatchCarouselModelValue">
            <slide v-for="(item, index) in colors" :key="'image' + index + '-image-swatch-' + item.name" class="swatch-spacer" role="none">
              <button type="button" :class="activePid == item.pid ? 'swatch-anchor activeSwatch' : 'swatch-anchor'" @click="setActiveColor(item.pid, index)" role="radio" :aria-checked="activePid == item.pid ? 'true' : 'false'">
                <img :src="buildSizedImageUrl(getImageSwatchImages(item), 60)" :srcset="getImageSwatchSrcSet(item)" sizes="50px" :alt="`${productTitle} color option: ${item.name}`" style="width: 100%" class="smallSwatches" :loading="enableLazyLoading ? 'lazy' : 'eager'" />
                <span v-html="item.name" class="visually-hidden"></span>
              </button>
            </slide>
            <template #addons>
              <navigation v-if="colors.length > gridSizeBasedSwatches" />
            </template>
          </carousel>
        </div>

        <!-- Color swatches with active color visibility guarantee -->
        <div class="imageCounter gt-p__small" v-html="setCounterMessage(colors.length)" v-if="hideSwatches != true && this.swatchSuffix && !this.productSwatchesHidden"></div>

        <!-- Vendor -->
        <p v-if="shouldShowVendor" class="product__grid__vendor gt-p__small" :style="{ color: vendorColorText }">
          <a v-if="vendorUrl" :href="vendorUrl" class="vendor-link" :style="{ color: vendorColorText, textDecoration: 'underline' }">{{ vendor }}</a>
          <template v-else>{{ vendor }}</template>
        </p>

        <!-- Product text details -->
        <a :href="setProductPDPLink(item.handle)" data-grid-link="">
          <div class="product__grid__title__wrapper" :class="{ 'has-no-vendor': !shouldShowVendor }" :data-product-type="item.productType" :data-color="item.name" :data-vendor="vendor" :data-price="item.price" :data-compare-price="item.compareAtPrice?.amount" :data-placement="index">
            <p :id="'product-' + item.pid" class="product__grid__title gt-p" v-html="productTitle"></p>
          </div>
          <div class="product__grid__price" v-if="ShouldDisplayComparePrice(item.compareAtPrice, item.price) && !colorHasPriceRange(item.handle)">
            <span class="price on-sale gt-p__small" v-html="convertToCurrency(item.price)"></span>
            <span class="compare-at gt-p__small" v-html="convertToCurrency(item.compareAtPrice?.amount)"></span>
            <small v-if="shouldShowSalePercentage" class="gt-p__small--x">
              <span class="percentage-off on-sale" v-html="'(' + Math.round((1 - item.price / item.compareAtPrice?.amount) * 100) + '% off)'"></span>
            </small>
          </div>
          <div class="product__grid__price gt-p__small" v-if="!ShouldDisplayComparePrice(item.compareAtPrice, item.price) && !colorHasPriceRange(item.handle)">
            <span class="price gt-p__small" v-html="convertToCurrency(item.price)"></span>
          </div>
          <p style="display: inline" :class="'price first_price gt-p__small ' + compareAtRangeClass(item.handle)" v-if="colorHasPriceRange(item.handle)" v-html="getPriceRangeMinByHandle(item.handle) + ' - ' + getPriceRangeMaxByHandle(item.handle) + ' '"></p>
          <p style="display: inline" :class="'price compare_at_price gt-p__small ' + compareAtRangeClass(item.handle)" v-if="colorHasPriceRange(item.handle)" v-html="getCompareAtPriceRangeMinByHandle(item.handle) + ' - ' + getCompareAtPriceRangeMaxByHandle(item.handle)"></p>
          <a v-if="showFullDetailsLink" class="gt-p__small view-product-details" :href="`${rootUrl}products/${item.handle}`">
            View Full Details <span class="visually-hidden">for {{ productTitle }}</span>
          </a>
          <ProductListTextUnderBadge :tags="item.tags" :collectionId="resolvedCollectionId" :badgeHideConfig="badgeHideConfig" :isPlp="true" :price="parseFloat(item.price) || 0" />
        </a>

        <!-- Compare products checkbox -->
        <!-- Kameleoon Compare PLP experiment: remove v-if="enableCompareResolved", use v-if="enableCompare" when experiment ends -->
        <div class="product__grid__compare kam-plp-compare" v-if="enableCompareResolved">
          <input type="checkbox" :id="'compare-product-' + item.pid" :checked="isItemCompared(item)" :disabled="isCompareDisabled(item)" @change.prevent="toggleCompare(item)" class="gt-p__small" />
          <label :for="'compare-product-' + item.pid" class="gt-p__small"
            >Compare
            <span class="visually-hidden">{{ item.name }}</span>
          </label>
        </div>

        <!-- Set a reminder - Klaviyo form - Popup -->
        <div class="product__grid__reminder" v-if="this.checkReminderTag(item.tags) && this.setReminderMetafield != '' && this.setReminderProductLink && this.setReminderPDP && this.setReminderPDPHideSizes && this.reminderFormIDPopup != '' && this.reminderFormIDPopup != null && this.setReminderLinkText != '' && this.setReminderLinkText != null">
          <button class="product__grid__reminder__button" :data-klaviyo-form-id-popup="this.reminderFormIDPopup" @click="this.triggerKlaviyoPopup">
            {{ this.setReminderLinkText }}
          </button>
        </div>

        <!-- Product category -->
        <div class="product__grid__combo_category gt-p__small" v-if="this.productCategoryMetafieldOne || this.productCategoryMetafieldTwo">
          <a v-if="this.productCategoryMetafieldOne && productCategoryMetafieldOneCollectionUrl && !productCategoryMetafieldOneCollectionUrl.startsWith('gid://')" :href="productCategoryMetafieldOneCollectionUrl" class="combo-category__one combo-category__link gt-p__small">{{ this.productCategoryMetafieldOne }}</a>
          <span v-else-if="this.productCategoryMetafieldOne" class="combo-category__one gt-p__small">{{ this.productCategoryMetafieldOne }}</span>
          <span class="combo-category__spacer gt-p__small" v-if="(this.productCategoryMetafieldOne || (productCategoryMetafieldOneCollectionUrl && !productCategoryMetafieldOneCollectionUrl.startsWith('gid://'))) && (this.productCategoryMetafieldTwo || (productCategoryMetafieldTwoCollectionUrl && !productCategoryMetafieldTwoCollectionUrl.startsWith('gid://')))">&bull;</span>
          <a v-if="this.productCategoryMetafieldTwo && productCategoryMetafieldTwoCollectionUrl && !productCategoryMetafieldTwoCollectionUrl.startsWith('gid://')" :href="productCategoryMetafieldTwoCollectionUrl" class="combo-category__two combo-category__link gt-p__small">{{ this.productCategoryMetafieldTwo }}</a>
          <span v-else-if="this.productCategoryMetafieldTwo" class="combo-category__two gt-p__small">{{ this.productCategoryMetafieldTwo }}</span>
        </div>
        <div class="product__grid__description gt-p__small" v-if="this.productPLPDescription">
          <span class="description">{{ this.productPLPDescription }}</span>
        </div>
        <div v-if="showRating && rating > 0" class="plp-rating" :style="{ '--plp-star-color': ratingStarColor || undefined, '--plp-count-color': ratingCountColor || undefined }">
          <span class="plp-rating__star" aria-hidden="true">★</span>
          <span class="plp-rating__text gt-p__small"
            ><span class="plp-rating__value">{{ Number(rating).toFixed(1) }}</span
            ><span v-if="ratingCount != null" class="plp-rating__count"> ({{ ratingCount }})</span></span
          >
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  #fs-collection-products {
    .has-no-vendor .product__grid__title {
      margin-top: 0;
    }

    .hide-me-false.imageCounter {
      opacity: 1;
    }

    .hide-me-true.imageCounter {
      opacity: 0;
    }

    .swatch_button_wrapper {
      display: flex;
      transition: opacity 0.3s ease-out;

      &.image_swatches {
        opacity: 0;
      }

      .swatch__button {
        display: flex;
        align-items: center;
        gap: 2px;
      }

      &.color_swatches .carousel__viewport {
        max-height: 60px;

        img {
          max-height: 50px;
        }
      }

      .hide-me {
        opacity: 0;
      }

      .carousel__slide {
        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }
      }

      .carousel__prev,
      .carousel__next {
        background-color: #fff;
        border: 1px solid #000;
        margin: 0;
        bottom: 0;
        height: 48px;

        &:hover {
          background-color: #000;
          color: #fff;
        }
      }

      .carousel__prev--disabled,
      .carousel__next--disabled {
        display: none;
      }
    }

    .carousel__pagination {
      display: flex;
      position: absolute;
      top: 0px;
      left: 5px;
      right: 5px;
      z-index: 1;
      opacity: 1;
      visibility: visible;
      transition: opacity 0.2s linear;
      transform: none;
      margin: 10px 0 0 !important;
      height: fit-content;

      .is-tablet & {
        top: 3px;
        margin-top: 5px;
      }
    }

    .carousel__pagination-button {
      .is-tablet &,
      .is-desktop & {
        top: 0px;
        padding-top: 0;
      }
    }

    .product-grid-item__slide-hit {
      display: block;
      height: 100%;
    }

    .hide-me-false {
      .carousel__prev,
      .carousel__next {
        display: flex;
      }
    }

    .hide-me-true {
      .carousel__prev,
      .carousel__next {
        display: none;
      }
    }

    .product-grid-item__content:not(.show-pagination-dots) .carousel__pagination {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }

    .show-pagination-dots .carousel__pagination {
      opacity: 1;
      visibility: visible;
    }

    .product-grid-carousel-wrap.is-peeking .carousel__pagination {
      display: none !important;
    }

    .product-grid-carousel-wrap.is-peeking .carousel__slide.peek-target {
      opacity: 1 !important;
    }

    .swatch__button.swatch__button--square {
      overflow: hidden;
    }

    .product-grid-item:hover {
      .swatch_button_wrapper {
        opacity: 1;
        transition: opacity 0.3s ease-out;
      }
    }

    .product-grid-item__container:hover {
      .is-tablet &,
      .is-desktop & {
        .product-grid-item__pagination {
          opacity: 1;
        }
      }
    }

    &[data-plp-top-badge-display='block'] {
      .product-grid-item .topLeftBadge.pdp-badge {
        display: var(--PDP-BADGE-DISPLAY);
      }
    }

    &[data-plp-top-badge-display='none'] {
      .is-desktop .product-grid-item:hover .topLeftBadge.pdp-badge,
      .is-tablet .product-grid-item:hover .topLeftBadge.pdp-badge {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition:
          opacity 0.2s ease,
          visibility 0.2s ease;
      }
    }

    &[data-plp-pill-hide-on-hover='true'] {
      .is-desktop .product-grid-item:hover .pillbadges,
      .is-tablet .product-grid-item:hover .pillbadges {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition:
          opacity 0.2s ease,
          visibility 0.2s ease;
      }

      .is-mobile .product-grid-item__container.show-pagination-dots .pillbadges {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition:
          opacity 0.2s ease,
          visibility 0.2s ease;
      }
    }

    .product__grid__info {
      padding-top: 15px;

      .color_swatches ~ .product__grid__vendor {
        margin-top: 10px;
      }

      &.no-swatches .product__grid__vendor {
        margin-top: 18px;
      }
    }

    .product-grid-item__pagination {
      span {
        --width: 1%;

        &.is-active {
          .growing {
            width: 100%;
            -webkit-transition: width 1s ease-in-out;
            -moz-transition: width 1s ease-in-out;
            -o-transition: width 1s ease-in-out;
            transition: width 1s ease-in-out;
          }
        }

        .growing {
          width: 1%;
          background-color: #000;
          display: block;
        }
      }
    }

    .swatch__label {
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
      }

      &.is-active {
        background-color: #ffffff;
        border: 2px solid #ffffff;
        color: #ffffff;
        outline: 1px solid #000000;
      }
    }

    .swatch-anchor {
      img {
        width: 100%;
        height: 100%;
        resize: both;
        overflow: auto;
        object-fit: cover;
      }
    }

    .product__grid__info a {
      display: block;
      text-decoration: none;
      color: var(--text-dark);
    }

    .product-grid-item a {
      display: block;
    }
  }

  a.view-product-details {
    text-decoration: underline;
    margin: 6px 0;
  }

  .plp-rating {
    display: flex;
    gap: 0;
    margin-top: 6px;
    align-items: center;
  }
  .plp-rating__star {
    color: var(--plp-star-color, var(--pc-text-on-bg, inherit));
    line-height: 18px;
    margin-right: 3px;
  }
  .plp-rating__count {
    color: var(--plp-count-color, #737373);
  }

  .product-comparison__item .plp-rating__value,
  .product-comparison__item .plp-rating__star,
  .product-comparison__item .plp-rating__text {
    color: var(--pc-text-on-bg, inherit);
  }
  .product-comparison__item .plp-rating__count {
    color: var(--pc-text-on-bg, var(--plp-count-color, #737373));
    opacity: 0.7;
  }

  #fs-collection-products {
    .is-mobile {
      .swatch_button_wrapper.image_swatches {
        opacity: 0 !important;
        display: none !important;
      }

      .swatch_button_wrapper.color_swatches,
      .plp-color-count,
      .plp-mini-swatch-count {
        opacity: 1;
        visibility: visible;
      }

      .carousel__pagination {
        top: 0px;
        margin-top: 5px;
        pointer-events: none;
      }

      .product-grid-item__image-link {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.08);
        cursor: pointer;
        touch-action: manipulation;
      }

      .product-grid-item__container.hide-me-true:not(.show-pagination-dots) .product-grid-carousel-wrap:has(:focus-visible) .carousel__pagination {
        display: flex !important;
        opacity: 1 !important;
        visibility: visible !important;
        transition: none;
      }

      .product__grid__info {
        padding-left: 8px;
        padding-right: 10px;
        padding-bottom: 8px;
      }
    }
  }

  .is-mobile .product-image-carousel.is-dragging .product-grid-item__image-link,
  .is-mobile .product-image-carousel.is-sliding .product-grid-item__image-link {
    pointer-events: none;
    touch-action: none;
  }

  /* .carousel__slide is a centering flex row, so without an explicit width these shrink to the image's sizes-based intrinsic width */
  .product-grid-item__slide-hit,
  .carousel__slide > .product-grid-item__image-link {
    width: 100%;
  }

  .product__grid__combo_category .combo-category__link {
    text-decoration: none;
    color: inherit;
  }

  .is-desktop .product__grid__combo_category .combo-category__link:hover {
    text-decoration: underline;
  }

  .is-mobile .product__grid__combo_category .combo-category__link,
  .is-tablet .product__grid__combo_category .combo-category__link {
    text-decoration: none;
  }

  .is-mobile .product__grid__combo_category .combo-category__link:hover,
  .is-tablet .product__grid__combo_category .combo-category__link:hover {
    text-decoration: none;
  }

  .product-image-carousel--no-drag {
    touch-action: auto;
  }

  .product-grid-item__image-link {
    display: block;
    height: 100%;
    color: inherit;
    text-decoration: none;
  }

  .product-grid-item__container .topLeftBadge,
  .product-grid-item__container .product__badge--sold {
    pointer-events: none;
  }

  // Pagination styles for ProductListItem image carousel.
  // Kept unscoped (not nested under #fs-collection-products) so they apply on
  // every surface that mounts the tile: collection page, recently-viewed,
  // header dropdown, brick blocks, recommendations fallbacks, etc.
  // Surface-specific overrides (ProductRecommendations.vue, CollectionSlider.vue)
  // remain more specific and continue to win where they exist.
  .product-image-carousel {
    .carousel__pagination {
      display: flex;
      position: absolute;
      top: 0px;
      left: 5px;
      right: 5px;
      z-index: 1;
      opacity: 1;
      visibility: visible;
      transition: opacity 0.2s linear;
      transform: none;
      margin: 10px 0 0 !important;
      height: fit-content;
    }

    .is-tablet & .carousel__pagination {
      top: 3px;
      margin-top: 5px;
    }

    .carousel__pagination-item {
      width: 20px;
      height: 1px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      border: 0;
      margin: 0 4px 0.25em 4px;
      cursor: pointer;
      padding: var(--vc-pgn-margin);
      padding-inline: 0;
      background: transparent;
      flex-grow: unset;
      border-radius: 0;
    }

    .carousel__pagination-item::before {
      content: none;
    }

    .carousel__pagination-button {
      .is-tablet &,
      .is-desktop & {
        top: 0px;
        padding-top: 0;
      }
    }

    .carousel__pagination-button::after {
      display: block;
      content: '';
      border-radius: var(--vc-pgn-border-radius);
      width: 20px;
      height: 1px;
      background-color: var(--vc-pgn-background-color);
    }

    .carousel__pagination-button.carousel__pagination-button--active::after {
      width: 20px;
      height: 1px;
      background-color: var(--vc-pgn-active-color);
    }
  }

  .product-grid-item__content:not(.show-pagination-dots) .product-image-carousel .carousel__pagination {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }

  .show-pagination-dots .product-image-carousel .carousel__pagination {
    opacity: 1;
    visibility: visible;
  }

  .product-grid-carousel-wrap.is-peeking .product-image-carousel .carousel__pagination {
    display: none !important;
  }

  .is-mobile {
    .product-image-carousel .carousel__pagination {
      top: 0px;
      margin-top: 5px;
      pointer-events: none;
    }

    .product-grid-item__container .product-image-carousel .carousel__pagination,
    .product-grid-item__container:hover .product-image-carousel .carousel__pagination,
    .product-grid-item__container:focus-within .product-image-carousel .carousel__pagination,
    .product-grid-carousel-wrap:hover .product-image-carousel .carousel__pagination,
    .product-grid-carousel-wrap:active .product-image-carousel .carousel__pagination,
    .product-grid-item__content.show-pagination-dots .product-image-carousel .carousel__pagination {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
  }

  #fs-collection-products .is-mobile {
    .product-image-carousel .carousel__pagination {
      display: flex !important;
    }

    .product-grid-item__content:not(.show-pagination-dots) .product-image-carousel .carousel__pagination {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }

    .product-grid-item__content.show-pagination-dots .product-image-carousel .carousel__pagination {
      display: flex !important;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }

  /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
  html.kam-plp-compare-off .product__grid__compare {
    display: none;
  }
  /* --- end Kameleoon Compare PLP experiment --- */
</style>
